import axios from "axios";

export default {
  state: {
    minimumQuantity: null,
    customRulesLocations: []
  },
  mutations: {
    SET_MINIMUM_QUANTITY(state, quantity) {
      state.minimumQuantity = quantity;
    },
    SET_CUSTOM_RULES_LOCATIONS(state, { data }) {
      state.customRulesLocations = data;
    },
    UPDATE_CUSTOM_RULE_LOCATION(state, { data }) {
      if (!state.customRulesLocations) return;

      const index = state.customRulesLocations.data.findIndex(
        (location) => location.id === data.id
      );

      if (index !== -1) {
        state.customRulesLocations.data.splice(index, 1, data);
      }
    }
  },

  actions: {
    async updateDefaultMinimumQuantity({ commit }, quantity) {
      try {
        const {data: response} = await axios.put("/api/settings/orders/minimum-quantities", {
          quantity: quantity,
        });

        commit("SET_MINIMUM_QUANTITY", response.data.value);

        return response;
      } catch (error) {
        throw error;
      }
    },
    async fetchLocationsWithCustomRules({ commit }, {page, per_page}) {
      const response = await axios.get("/api/settings/orders/minimum-quantities/locations", {params: {
        page: page,
        per_page: per_page
      }});

      console.log(response)
      commit("SET_CUSTOM_RULES_LOCATIONS", {
        data: response.data,
      });
    },
    async setLocationOrderMinimumQuantity({ commit }, {location_id, quantity}) {
      try {
        const response = await axios.put(`/api/settings/orders/minimum-quantities/locations/${location_id}`, {
          quantity: quantity,
        });

        commit("UPDATE_CUSTOM_RULE_LOCATION", response.data);

        return response;
      } catch (error) {
        throw error;
      }
    },
    async getMinimumQuantity({ commit }) {
      try {
        const {data: response} = await axios.get("/api/settings/orders/minimum-quantities");

        commit("SET_MINIMUM_QUANTITY", response.data.value);

        return response;
      } catch (error) {
        throw error;
      }
    }
  },

  getters: {
    getOrderDefaultMinimumQuantity: (state) => state.minimumQuantity,
    getCustomRulesLocations: (state) => state.customRulesLocations,
  },
}